import { api } from './base';

import { MutationArg } from 'v2/types';
import { CasinoModel } from 'v2/types/CasinoModel';
import { SWRKeyValue } from 'v2/types/swr';

export const casinoService = {
  getCasinos(): Promise<CasinoModel[]> {
    return api.get('v1/admin/casino').json();
  },

  createCasino(_key: string, { arg }: MutationArg<Omit<CasinoModel, 'id' | 'order'>>): Promise<CasinoModel> {
    return api.post('v1/admin/casino', { json: arg }).json();
  },

  updateCasino(
    [_key, casinoId]: SWRKeyValue,
    { arg }: MutationArg<Omit<CasinoModel, 'id' | 'order' | 'isActive'>>
  ): Promise<CasinoModel> {
    return api.put(`v1/admin/casino/${casinoId}`, { json: arg }).json();
  },

  deleteCasino([_key, casinoId]: SWRKeyValue): Promise<void> {
    return api.delete(`v1/admin/casino/${casinoId}`).json();
  },

  setActiveCasino([_key, casinoId]: SWRKeyValue, { arg: isActive }: MutationArg<boolean>): Promise<CasinoModel> {
    return api.patch(`v1/admin/casino/${casinoId}/active`, { json: { isActive } }).json();
  },

  changeCasinosOrder(
    _key: string,
    { arg: orders }: MutationArg<Pick<CasinoModel, 'id' | 'order'>[]>
  ): Promise<CasinoModel[]> {
    return api.patch('v1/admin/casino/order', { json: { orders } }).json();
  },
};
